import React, { useEffect, useState } from 'react';
import { ReactComponent as CloseIcon } from '@Assets/icons/close.svg';
import { ReactComponent as MenuIcon } from '@Assets/icons/menu.svg';
import { HeadContext } from '../../Provider';
import SearchComponent from '../Search';
import { routes } from '../../routeConfig';
import { Link } from 'react-router-dom';
import './index.scss';
export default function Header (props:any) {
    const [ showMenu , setShowMenu ] = useState(false);
    const [ showSearch , setShowSearch ] = useState(false);

    function hideMenu () {
        setShowMenu(false);
    }

    function closeSearch () {
        setShowSearch(false);
    }

    return (
        <HeadContext.Provider value={{showSearch, setShowSearch}}>
            <div className={`c_header ${props.className}`}>
                <Link to={"/"} onClick={hideMenu} ><img className="c_header__logo" src="/images/logo.png"/></Link>
                <nav className={`c_header__nav ${showMenu ? 'show': ''}`}>
                    <Link to={routes.QuienesSomos.path} onClick={hideMenu} className="c_header__nav_item e-h1 e-h6:sm">QUIÉNES SOMOS</Link>
                    <Link to={routes.AspectoLegal.path} onClick={hideMenu} className="c_header__nav_item e-h1 e-h6:sm">ASPECTOS LEGALES</Link>
                    <Link to={routes.ApoyaMali.path} onClick={hideMenu} className="c_header__nav_item e-h1 e-h6:sm">APOYO AL MALI</Link>
                    <Link to={routes.Colecciones.path} onClick={hideMenu} className="c_header__nav_item e-h1 e-h6:sm">COLECCIONES</Link>
                    <Link to={routes.RecursosPedagogicos.path} onClick={hideMenu} className="c_header__nav_item e-h1 e-h6:sm">RECURSOS PEDAGÓGICOS</Link>
                    <a onClick={()=>{ setShowSearch(true); setShowMenu(false) }} className="c_header__nav_item e-h1 e-h6:sm" href="#">BUSCAR</a>
                    <button className="c_header__nav_button_close" onClick={()=>{setShowMenu(false)}}>
                        <CloseIcon width="100%" />
                    </button>
                </nav>
                <div className="c_header__nav_menu" onClick={()=>{setShowMenu(true)}}>
                    <MenuIcon width="25px" />
                </div>
                { showSearch &&
                    <SearchComponent handleClose={closeSearch}/>
                }
            </div>
        </HeadContext.Provider>
    )
}